import {useContext} from 'react';

import {ReactSubscriptionsContext} from '@udemy/subscription-graphql';

import {SubscriptionPlanProductType} from 'src/generated/graphql';

export const useIsGwgAvailable = (): boolean => {
    const subscriptionPlans = useContext(ReactSubscriptionsContext);
    const [gwgSubscriptionPlan, gwgPlusPPSubscriptionPlan] = [
        subscriptionPlans[SubscriptionPlanProductType.GrowWithGoogle],
        subscriptionPlans[SubscriptionPlanProductType.ConsumersubscriptionPlusGrowWithGoogle],
    ];

    const gwgPlans = [gwgSubscriptionPlan, gwgPlusPPSubscriptionPlan];

    return gwgPlans.some(
        (plan) => !!(plan && !plan.isLoading && ('id' in plan || plan.isSubscriberToSpecificPlan)),
    );
};
